import AppRoutes from "./Components/routes/AppRoutes";
import { LoaderProvider } from "./Components/service/Hooks/useLoader";
import "./Components/admin/Titles/style/ListeSecurities.css";

function App() {

  return (
    <>
      <LoaderProvider>
        <AppRoutes/>
      </LoaderProvider>
    </>
  );
};


export default App;

